import { SlButton, SlIcon, SlInput } from '@shoelace-style/shoelace/dist/react'
import React, { useEffect, useState } from 'react'
import TableSkelton from '../../shared/TableSkelton'
import NoDataFound from '../../shared/NoDataFound'
import API from '../../services/api'
import ZoneCreation from './ZoneCreation'
import { Toast } from '../../shared/Toast'
import { formatDateDDMMYYY } from '../../utils/dateFormat'
import { debounce } from '../../utils/Debounce'
import '../creatives/CreativeList.scss'

function Zones() {
    const [showAdd, setShowAdd] = useState(false)
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [flag, setFlag] = useState('add')
    const [search, setSearch] = useState('')
    const [editData, setEditData] = useState({})
    const handleAdd = () =>{
        setShowAdd(true)
        setFlag('add')
        setEditData({})
    }
    const loadData = async() =>{
        try {
            setLoading(true)
            let res = await API({
                url:'/zones/get',
                method:'POST',
                responseType:'json',
                data:{
                    search
                }
            })
            if(res.code === 200){
                setData(res.data)
            }
        } catch (error) {
            console.error(error)
        }
        finally{
            setLoading(false)
        }
    }
    const toggleStatus = async(status, zone_id)=>{
        try {
            let res = await API({
                url:'/zones/status',
                method:'POST',
                responseType:'json',
                data:{
                    status,zone_id
                }
            })
            if(res.code === 200){
                Toast('success', "Status update Successfull!")
                loadData()
            }
        } catch (error) {
            console.error(error)
        }
    }
    const searchData = (e)=>{
        setSearch(e.target.value);
    }
    useEffect(()=>{
        loadData()
    },[search])
  return (
    <>
      <div className="creativeListPage">
        <div className="cl-card">
          <header className="cl-header">
            <div className="cl-title-block">
              <h1 className="cl-title">Zones</h1>
              <p className="cl-subtitle">Manage delivery zones by language, state, district and constituency</p>
            </div>
            <div className="cl-toolbar cl-toolbar--inline">
              <SlInput
                className="cl-search"
                size="medium"
                type="text"
                placeholder="Enter zone name"
                value={search}
                onSlInput={debounce(searchData, 500)}>
                <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
              </SlInput>
              <SlButton variant="primary" size="medium" onClick={handleAdd}>
                <SlIcon library="lucide" name="plus" slot="prefix"></SlIcon>
                Add Zone
              </SlButton>
            </div>
          </header>

          <div className="cl-table-wrap">
            <table className="cl-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Zone Name</th>
                  <th>Language</th>
                  <th>States</th>
                  <th>Districts</th>
                  <th>Constituencies</th>
                  <th>Created On</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              {(!loading && data.length > 0) ? (
                <tbody>
                  {data.map((row, index) => (
                    <tr key={row.zone_id}>
                      <td data-label="S.No">{index + 1}</td>
                      <td className="cl-name" data-label="Zone Name">{row.zone_name}</td>
                      <td data-label="Language">{row.lang_id === 1 ? 'Telugu' : 'Tamil'}</td>
                      <td data-label="States">{row.state_names?.join(", ")}</td>
                      <td data-label="Districts">{row.district_names?.join(", ")}</td>
                      <td data-label="Constituencies">{row.constituency_names?.join(", ")}</td>
                      <td data-label="Created On">{formatDateDDMMYYY(row.created_on)}</td>
                      <td data-label="Status">
                        <span className="cl-switch">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              checked={row.status}
                              onChange={(e) => { toggleStatus(row.status, row.zone_id) }}
                            />
                          </div>
                        </span>
                      </td>
                      <td data-label="Actions">
                        <div className="cl-actions">
                          <sl-tooltip content="Edit Zone">
                            <sl-icon-button
                              library="lucide"
                              name="edit"
                              onClick={() => {
                                setShowAdd(true)
                                setFlag("edit");
                                setEditData(row)
                              }}
                            ></sl-icon-button>
                          </sl-tooltip>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : loading ? <TableSkelton colspan={9} /> : <NoDataFound colspan={9} />}
            </table>
          </div>
        </div>
      </div>

      <ZoneCreation show={showAdd} setShow={setShowAdd} loadData={loadData} flag={flag} editData={editData} />
    </>
  )
}

export default Zones
